import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMorocco = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1415)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#D80027"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M19.0916 9.84796H13.6741L12 4.69565L10.3259 9.84796H4.90837L9.29123 13.0323L7.61709 18.1847L12 15.0004L16.3829 18.1848L14.7088 13.0323L19.0916 9.84796ZM10.5179 12.6337L11.084 10.8914H12.9159L13.4821 12.6337V12.6337L12 13.7105L10.5179 12.6337L10.5179 12.6337ZM12.5769 9.84796H11.4231L12 8.07233L12.5769 9.84796ZM14.3697 11.9888L14.0131 10.8914H15.8801L14.3697 11.9888ZM9.98685 10.8914L9.63028 11.9888L8.11982 10.8914H9.98685ZM9.60192 15.4528L10.1789 13.6773L11.1124 14.3555L9.60192 15.4528ZM12.8876 14.3555L13.8211 13.6773L14.3981 15.4529L12.8876 14.3555Z",
			fill: "#FFDA44"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1415",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMorocco;
